<template>
  <v-toolbar text dark height="64px">
    <v-list>
      <v-list-item class="px-0">
        <v-list-item-avatar class="tile-menu-avatar" v-if="!isLoggedAs">
          <div class="menu-avatar" v-text="user_avatar">?</div>
        </v-list-item-avatar>
        <v-list-item-avatar class="menu-avatar" v-if="isLoggedAs">
          <v-icon>transfer_within_a_station</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="user_login"> </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-toolbar>
</template>

<script>
export default {
  name: "MainMenuHeader",
  //el: "#main-menu",
  data() {
    return {};
  },
  computed: {
    isLoggedAs() {
      return this.$store.getters.userProperties != null && typeof this.$store.getters.userProperties.context_user_login !== "undefined";
    },
    user_login: function() {
      if (this.$store.getters.userProperties != null) {
        if (typeof this.$store.getters.userProperties.context_user_login !== "undefined") {
          return this.$store.getters.userProperties.context_user_login;
        }
        return this.$store.getters.userProperties.login;
      }
      return this.$t("global.menu.notLogged");
    },
    user_avatar: function() {
      if (this.$store.getters.userProperties != null) {
        if (typeof this.$store.getters.userProperties.context_user_login !== "undefined") {
          return null;
        }
        return this.$store.getters.userProperties.name[0].toUpperCase() + this.$store.getters.userProperties.surname[0].toUpperCase();
      }
      return "?";
    },
    is_user_logged: function() {
      return this.$store.getters.isAuthenticated;
    }
  },
  methods: {}
};
</script>

<style scoped>
.menu-avatar {
  width: 48px;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  vertical-align: middle;
}

.tile-menu-avatar {
  width: 48px;
}

.v-toolbar__content {
  padding: 0;
}

.v-avatar {
  width: 48px !important;
}
</style>
